"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaSettings = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const _routeSearch_1 = __importStar(require("@front/pages/settings/social-media-gate/_routeSearch"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="${x => x.loading ? '' : 'd-none'}">
    <app-loader block="true" width="32" height="32"></app-loader>
</div>

<div class="${x => x.loading ? 'd-none' : ''}">
    <div class="cs-list">
        <div class="cs-list-head">
            <div style="width:40px;"></div>
            <div class="flex-grow-1">${'settings.socialMedia.column.platform'.t()}</div>
            <div style="width:100px;">${'settings.socialMedia.column.status'.t()}</div>
            <div style="width:78px;"></div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-x" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.x.title'.t()}"><i
                    class="iconsminds-twitter"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.x.title'.t()}</div>
                <div class="ch-sub">${x => x.xConnected && x.xUsername ? '@' + x.xUsername :
    'settings.socialMedia.x.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.xConnected ? 'on' : 'off'}" style="width:100px;"><span
                    class="dot"></span>${x => x.xConnected ? 'settings.status.connected'.t() :
    'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.xConnected ? 'd-none' : ''}"
                    :disabled="${x => x.xConnecting}" @click="${x => x.connectX()}"
                    title="${'settings.socialMedia.x.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.xConnected ? '' : 'd-none'}"
                    :disabled="${x => x.xConnecting}" @click="${x => x.disconnectX()}"
                    title="${'settings.socialMedia.x.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-facebook" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.fb.title'.t()}"><i
                    class="iconsminds-facebook"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.fb.title'.t()}</div>
                <div class="ch-sub">${x => x.fbConnected && x.fbUsername ? x.fbUsername :
    'settings.socialMedia.fb.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.fbConnected ? 'on' : 'off'}" style="width:100px;"><span
                    class="dot"></span>${x => x.fbConnected ? 'settings.status.connected'.t() :
    'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.fbConnected ? 'd-none' : ''}"
                    :disabled="${x => x.fbConnecting}" @click="${x => x.connectFb()}"
                    title="${'settings.socialMedia.fb.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.fbConnected ? '' : 'd-none'}"
                    :disabled="${x => x.fbConnecting}" @click="${x => x.disconnectFb()}"
                    title="${'settings.socialMedia.fb.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-instagram" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.ig.title'.t()}"><i class="iconsminds-instagram"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.ig.title'.t()}</div>
                <div class="ch-sub">${x => x.igConnected && x.igUsername ? '@' + x.igUsername : 'settings.socialMedia.ig.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.igConnected ? 'on' : 'off'}" style="width:100px;"><span class="dot"></span>${x => x.igConnected ? 'settings.status.connected'.t() : 'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.igConnected ? 'd-none' : ''}" :disabled="${x => x.igConnecting}" @click="${x => x.connectIg()}" title="${'settings.socialMedia.ig.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.igConnected ? '' : 'd-none'}" :disabled="${x => x.igConnecting}" @click="${x => x.disconnectIg()}" title="${'settings.socialMedia.ig.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-youtube" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.yt.title'.t()}"><i
                    class="iconsminds-youtube"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.yt.title'.t()}</div>
                <div class="ch-sub">${x => x.ytConnected && x.ytUsername ? x.ytUsername :
    'settings.socialMedia.yt.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.ytConnected ? 'on' : 'off'}" style="width:100px;"><span
                    class="dot"></span>${x => x.ytConnected ? 'settings.status.connected'.t() :
    'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.ytConnected ? 'd-none' : ''}"
                    :disabled="${x => x.ytConnecting}" @click="${x => x.connectYt()}"
                    title="${'settings.socialMedia.yt.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.ytConnected ? '' : 'd-none'}"
                    :disabled="${x => x.ytConnecting}" @click="${x => x.disconnectYt()}"
                    title="${'settings.socialMedia.yt.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-tiktok" style="width:40px;height:40px;font-size:13px;" title="${'settings.socialMedia.tt.title'.t()}">TT</span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.tt.title'.t()}</div>
                <div class="ch-sub">${x => x.ttConnected && x.ttUsername ? x.ttUsername :
    'settings.socialMedia.tt.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.ttConnected ? 'on' : 'off'}" style="width:100px;"><span
                    class="dot"></span>${x => x.ttConnected ? 'settings.status.connected'.t() :
    'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.ttConnected ? 'd-none' : ''}"
                    :disabled="${x => x.ttConnecting}" @click="${x => x.connectTt()}"
                    title="${'settings.socialMedia.tt.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.ttConnected ? '' : 'd-none'}"
                    :disabled="${x => x.ttConnecting}" @click="${x => x.disconnectTt()}"
                    title="${'settings.socialMedia.tt.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-linkedin" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.li.title'.t()}"><i class="iconsminds-linkedin-2"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.li.title'.t()}</div>
                <div class="ch-sub">${x => x.liConnected && x.liUsername ? x.liUsername : 'settings.socialMedia.li.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.liConnected ? 'on' : 'off'}" style="width:100px;"><span class="dot"></span>${x => x.liConnected ? 'settings.status.connected'.t() : 'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.liConnected ? 'd-none' : ''}" :disabled="${x => x.liConnecting}" @click="${x => x.connectLi()}" title="${'settings.socialMedia.li.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.liConnected ? '' : 'd-none'}" :disabled="${x => x.liConnecting}" @click="${x => x.disconnectLi()}" title="${'settings.socialMedia.li.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-pinterest" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.pt.title'.t()}"><i class="iconsminds-pinterest"></i></span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.pt.title'.t()}</div>
                <div class="ch-sub">${x => x.ptConnected && x.ptUsername ? x.ptUsername : 'settings.socialMedia.pt.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.ptConnected ? 'on' : 'off'}" style="width:100px;"><span class="dot"></span>${x => x.ptConnected ? 'settings.status.connected'.t() : 'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.ptConnected ? 'd-none' : ''}" :disabled="${x => x.ptConnecting}" @click="${x => x.connectPt()}" title="${'settings.socialMedia.pt.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.ptConnected ? '' : 'd-none'}" :disabled="${x => x.ptConnecting}" @click="${x => x.disconnectPt()}" title="${'settings.socialMedia.pt.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        
        <div class="cs-list-row channel-row">
            <span class="pf-badge pf-threads" style="width:40px;height:40px;font-size:17.6px;" title="${'settings.socialMedia.th.title'.t()}">@</span>
            <div class="ch-meta">
                <div class="ch-name">${'settings.socialMedia.th.title'.t()}</div>
                <div class="ch-sub">${x => x.thConnected && x.thUsername ? '@' + x.thUsername : 'settings.socialMedia.th.description'.t()}</div>
            </div>
            <span class="status-pill ${x => x.thConnected ? 'on' : 'off'}" style="width:100px;"><span class="dot"></span>${x => x.thConnected ? 'settings.status.connected'.t() : 'settings.status.notConnected'.t()}</span>
            <div class="d-flex" style="gap:4px; width:78px;">
                <button type="button" class="btn btn-outline-secondary btn-sm ${x => x.thConnected ? 'd-none' : ''}" :disabled="${x => x.thConnecting}" @click="${x => x.connectTh()}" title="${'settings.socialMedia.th.connect'.t()}"><i class="simple-icon-link"></i></button>
                <button type="button" class="btn btn-outline-danger btn-sm ${x => x.thConnected ? '' : 'd-none'}" :disabled="${x => x.thConnecting}" @click="${x => x.disconnectTh()}" title="${'settings.socialMedia.th.disconnect'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
        </div>

        <sm-dictionary-manager></sm-dictionary-manager>
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  --cs-primary: #5B3DF6;
  --cs-ink-100: #EFF1F4;
  --cs-ink-200: #E2E5EA;
  --cs-ink-400: #9199A8;
  --cs-ink-500: #6B7180;
  --cs-ink-800: #22252C;
  --cs-bg: #F6F6FA;
  --cs-success: #16A34A;
  --cs-success-soft: #E9F9EF;
  --cs-danger: #DC2626;
  --cs-danger-soft: #FDEAEA;
  --cs-radius-sm: 8px;
  --cs-radius-md: 12px;
  --cs-radius-pill: 999px;
  --cs-shadow-xs: 0 1px 2px rgba(20, 20, 43, 0.05);
  display: block;
}

.cs-list {
  border: 1px solid var(--cs-ink-100);
  border-radius: var(--cs-radius-md);
  overflow: hidden;
  background: #fff;
  box-shadow: var(--cs-shadow-xs);
}

.cs-list-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 18px;
  border-bottom: 1px solid var(--cs-ink-100);
  transition: background 0.12s;
}
.cs-list-row:last-child {
  border-bottom: none;
}
.cs-list-row:hover {
  background: var(--cs-bg);
}

.cs-list-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 18px;
  background: var(--cs-bg);
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--cs-ink-400);
  border-bottom: 1px solid var(--cs-ink-100);
}

.channel-row .ch-meta {
  flex: 1;
  min-width: 0;
}
.channel-row .ch-name {
  font-weight: 700;
  font-size: 0.86rem;
  color: var(--cs-ink-800);
}
.channel-row .ch-sub {
  font-size: 0.72rem;
  color: var(--cs-ink-400);
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: var(--cs-radius-pill);
  padding: 3px 10px;
}
.status-pill .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.status-pill.on {
  background: var(--cs-success-soft);
  color: var(--cs-success);
}
.status-pill.off {
  background: var(--cs-ink-100);
  color: var(--cs-ink-400);
}

.pf-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
  border-radius: 50%;
  line-height: 1;
}
.pf-badge.pf-facebook {
  background: #1877F2;
}
.pf-badge.pf-pinterest {
  background: #b4002d;
}
.pf-badge.pf-threads {
  background: #000;
}
.pf-badge.pf-x {
  background: #000;
}
.pf-badge.pf-youtube {
  background: #FF0000;
}
.pf-badge.pf-tiktok {
  background: linear-gradient(135deg, #25F4EE, #111 45%, #FE2C55);
}
.pf-badge.pf-linkedin {
  background: #0A66C2;
}
.pf-badge.pf-instagram {
  background: radial-gradient(circle, rgb(63, 94, 251) 0%, rgb(252, 70, 107) 100%);
}

.btn {
  border-radius: var(--cs-radius-sm);
  font-weight: 600;
}

.btn-outline-secondary {
  color: var(--cs-ink-500);
  border-color: var(--cs-ink-200);
}
.btn-outline-secondary:hover {
  background: var(--cs-ink-100);
  color: var(--cs-ink-800);
}

.btn-outline-danger {
  color: var(--cs-danger);
  border-color: #f3c8c8;
}
.btn-outline-danger:hover {
  background: var(--cs-danger-soft);
}`;
const shadowOptions = { "mode": "open" };
let SocialMediaSettings = class SocialMediaSettings extends client_1.RWSViewComponent {
    constructor(routeSearchService) {
        super();
        this.routeSearchService = routeSearchService;
        this.loading = false;
        this.xConnected = false;
        this.xUsername = '';
        this.xConnecting = false;
        this.fbConnected = false;
        this.fbUsername = '';
        this.fbConnecting = false;
        this.igConnected = false;
        this.igUsername = '';
        this.igConnecting = false;
        this.ytConnected = false;
        this.ytUsername = '';
        this.ytConnecting = false;
        this.ttConnected = false;
        this.ttUsername = '';
        this.ttConnecting = false;
        this.liConnected = false;
        this.liUsername = '';
        this.liConnecting = false;
        this.ptConnected = false;
        this.ptUsername = '';
        this.ptConnecting = false;
        this.thConnected = false;
        this.thUsername = '';
        this.thConnecting = false;
        this.proxy = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadStatus();
    }
    async loadStatus() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.loading = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.status', undefined, undefined, 'GET') : await this.apiService.back.get('settings.social-media.status');
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.xConnected = response.data.x.connected;
                this.xUsername = response.data.x.username || '';
                this.fbConnected = response.data.fb.connected;
                this.fbUsername = response.data.fb.username || '';
                this.igConnected = ((_a = response.data.ig) === null || _a === void 0 ? void 0 : _a.connected) || false;
                this.igUsername = ((_b = response.data.ig) === null || _b === void 0 ? void 0 : _b.username) || '';
                this.ytConnected = ((_c = response.data.youtube) === null || _c === void 0 ? void 0 : _c.connected) || false;
                this.ytUsername = ((_d = response.data.youtube) === null || _d === void 0 ? void 0 : _d.username) || '';
                this.ttConnected = ((_e = response.data.tiktok) === null || _e === void 0 ? void 0 : _e.connected) || false;
                this.ttUsername = ((_f = response.data.tiktok) === null || _f === void 0 ? void 0 : _f.username) || '';
                this.liConnected = ((_g = response.data.linkedin) === null || _g === void 0 ? void 0 : _g.connected) || false;
                this.liUsername = ((_h = response.data.linkedin) === null || _h === void 0 ? void 0 : _h.username) || '';
                this.ptConnected = ((_j = response.data.pinterest) === null || _j === void 0 ? void 0 : _j.connected) || false;
                this.ptUsername = ((_k = response.data.pinterest) === null || _k === void 0 ? void 0 : _k.username) || '';
                this.thConnected = ((_l = response.data.threads) === null || _l === void 0 ? void 0 : _l.connected) || false;
                this.thUsername = ((_m = response.data.threads) === null || _m === void 0 ? void 0 : _m.username) || '';
            }
        }
        catch (error) {
            console.error('Failed to load social media status:', error);
        }
        finally {
            this.loading = false;
        }
    }
    async connectX() {
        var _a;
        this.xConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.x.auth') : await this.apiService.back.post('settings.social-media.x.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'XAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.xConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.x.connectFailed'.t(), 'error');
                this.xConnecting = false;
            }
        }
        catch (error) {
            console.error('X connect failed:', error);
            this.notifyService.notify('settings.socialMedia.x.connectFailed'.t(), 'error');
            this.xConnecting = false;
        }
    }
    async disconnectX() {
        this.xConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.x.disconnect') : await this.apiService.back.post('settings.social-media.x.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.xConnected = false;
                this.xUsername = '';
                this.notifyService.notify('settings.socialMedia.x.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.x.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('X disconnect failed:', error);
            this.notifyService.notify('settings.socialMedia.x.disconnectFailed'.t(), 'error');
        }
        finally {
            this.xConnecting = false;
        }
    }
    async connectFb() {
        var _a;
        this.fbConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.fb.auth') : await this.apiService.back.post('settings.social-media.fb.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'FbAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.fbConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.fb.connectFailed'.t(), 'error');
                this.fbConnecting = false;
            }
        }
        catch (error) {
            console.error('FB connect failed:', error);
            this.notifyService.notify('settings.socialMedia.fb.connectFailed'.t(), 'error');
            this.fbConnecting = false;
        }
    }
    async disconnectFb() {
        this.fbConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.fb.disconnect') : await this.apiService.back.post('settings.social-media.fb.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.fbConnected = false;
                this.fbUsername = '';
                this.notifyService.notify('settings.socialMedia.fb.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.fb.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.fb.disconnectFailed'.t(), 'error');
        }
        finally {
            this.fbConnecting = false;
        }
    }
    async connectIg() {
        var _a;
        this.igConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.ig.auth') : await this.apiService.back.post('settings.social-media.ig.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'IgAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.igConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.ig.connectFailed'.t(), 'error');
                this.igConnecting = false;
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.ig.connectFailed'.t(), 'error');
            this.igConnecting = false;
        }
    }
    async disconnectIg() {
        this.igConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.ig.disconnect') : await this.apiService.back.post('settings.social-media.ig.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.igConnected = false;
                this.igUsername = '';
                this.notifyService.notify('settings.socialMedia.ig.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.ig.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.ig.disconnectFailed'.t(), 'error');
        }
        finally {
            this.igConnecting = false;
        }
    }
    async connectYt() {
        var _a;
        this.ytConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.yt.auth') : await this.apiService.back.post('settings.social-media.yt.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'YtAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.ytConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.yt.connectFailed'.t(), 'error');
                this.ytConnecting = false;
            }
        }
        catch (error) {
            console.error('YT connect failed:', error);
            this.notifyService.notify('settings.socialMedia.yt.connectFailed'.t(), 'error');
            this.ytConnecting = false;
        }
    }
    async disconnectYt() {
        this.ytConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.yt.disconnect') : await this.apiService.back.post('settings.social-media.yt.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.ytConnected = false;
                this.ytUsername = '';
                this.notifyService.notify('settings.socialMedia.yt.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.yt.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('YT disconnect failed:', error);
            this.notifyService.notify('settings.socialMedia.yt.disconnectFailed'.t(), 'error');
        }
        finally {
            this.ytConnecting = false;
        }
    }
    async connectTt() {
        var _a;
        this.ttConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.tt.auth') : await this.apiService.back.post('settings.social-media.tt.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'TtAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.ttConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.tt.connectFailed'.t(), 'error');
                this.ttConnecting = false;
            }
        }
        catch (error) {
            console.error('TT connect failed:', error);
            this.notifyService.notify('settings.socialMedia.tt.connectFailed'.t(), 'error');
            this.ttConnecting = false;
        }
    }
    async disconnectTt() {
        this.ttConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.tt.disconnect') : await this.apiService.back.post('settings.social-media.tt.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.ttConnected = false;
                this.ttUsername = '';
                this.notifyService.notify('settings.socialMedia.tt.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.tt.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('TT disconnect failed:', error);
            this.notifyService.notify('settings.socialMedia.tt.disconnectFailed'.t(), 'error');
        }
        finally {
            this.ttConnecting = false;
        }
    }
    async connectLi() {
        var _a;
        this.liConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.li.auth') : await this.apiService.back.post('settings.social-media.li.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'LiAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.liConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.li.connectFailed'.t(), 'error');
                this.liConnecting = false;
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.li.connectFailed'.t(), 'error');
            this.liConnecting = false;
        }
    }
    async disconnectLi() {
        this.liConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.li.disconnect') : await this.apiService.back.post('settings.social-media.li.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.liConnected = false;
                this.liUsername = '';
                this.notifyService.notify('settings.socialMedia.li.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.li.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.li.disconnectFailed'.t(), 'error');
        }
        finally {
            this.liConnecting = false;
        }
    }
    async connectPt() {
        var _a;
        this.ptConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.pt.auth') : await this.apiService.back.post('settings.social-media.pt.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'PtAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.ptConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.pt.connectFailed'.t(), 'error');
                this.ptConnecting = false;
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.pt.connectFailed'.t(), 'error');
            this.ptConnecting = false;
        }
    }
    async disconnectPt() {
        this.ptConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.pt.disconnect') : await this.apiService.back.post('settings.social-media.pt.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.ptConnected = false;
                this.ptUsername = '';
                this.notifyService.notify('settings.socialMedia.pt.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.pt.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.pt.disconnectFailed'.t(), 'error');
        }
        finally {
            this.ptConnecting = false;
        }
    }
    async connectTh() {
        var _a;
        this.thConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.th.auth') : await this.apiService.back.post('settings.social-media.th.auth', {});
            if ((response === null || response === void 0 ? void 0 : response.success) && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.authUrl)) {
                const popup = window.open(response.data.authUrl, 'ThAuth', 'width=500,height=700,scrollbars=yes,resizable=yes');
                const check = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(check);
                        this.thConnecting = false;
                        this.loadStatus();
                    }
                }, 1000);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.th.connectFailed'.t(), 'error');
                this.thConnecting = false;
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.th.connectFailed'.t(), 'error');
            this.thConnecting = false;
        }
    }
    async disconnectTh() {
        this.thConnecting = true;
        try {
            const response = this.proxy ? await this.routeSearchService.callGatedBackend('settings.social-media.th.disconnect') : await this.apiService.back.post('settings.social-media.th.disconnect', {});
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.thConnected = false;
                this.thUsername = '';
                this.notifyService.notify('settings.socialMedia.th.disconnected'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.th.disconnectFailed'.t(), 'error');
            }
        }
        catch (error) {
            this.notifyService.notify('settings.socialMedia.th.disconnectFailed'.t(), 'error');
        }
        finally {
            this.thConnecting = false;
        }
    }
};
exports.SocialMediaSettings = SocialMediaSettings;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "xConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "xUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "xConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "fbConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "fbUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "fbConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "igConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "igUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "igConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ytConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "ytUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ytConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ttConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "ttUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ttConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "liConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "liUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "liConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ptConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "ptUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "ptConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "thConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaSettings.prototype, "thUsername", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "thConnecting", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SocialMediaSettings.prototype, "proxy", void 0);
exports.SocialMediaSettings = SocialMediaSettings = __decorate([
    (0, client_1.RWSView)('settings-social-media', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(_routeSearch_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof _routeSearch_1.RouteSearchServiceInstance !== "undefined" && _routeSearch_1.RouteSearchServiceInstance) === "function" ? _a : Object])
], SocialMediaSettings);
SocialMediaSettings.defineComponent();
